import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6720c06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-body" }
const _hoisted_2 = { class: "mb-10" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "firstName",
  class: "form-label"
}, "Name", -1))
const _hoisted_4 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_5 = { class: "mb-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "backgroundColor",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("h5", { class: "m-0" }, "Background Color")
], -1))
const _hoisted_7 = {
  id: "colorPicker",
  class: "ml-3 mt-3 mb-3"
}
const _hoisted_8 = ["id", "onClick"]
const _hoisted_9 = {
  key: 0,
  class: "fa-regular fa-circle-check color-check"
}
const _hoisted_10 = { class: "mb-10" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-5" }, "Select a Group Icon", -1))
const _hoisted_13 = { class: "modal-footer" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  id: "closeAddBiModal",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Cancel ", -1))
const _hoisted_15 = {
  key: 0,
  type: "submit",
  class: "btn btn-light",
  disabled: ""
}
const _hoisted_16 = {
  key: 1,
  type: "submit",
  class: "btn btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("form", {
    class: "form",
    onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          name: "firstName",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event)),
          class: "form-control form-control-solid",
          id: "firstName"
        }, null, 512), [
          [_vModelText, _ctx.state.name]
        ]),
        (_ctx.v$.name.$error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.v$.name.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors, (color, index) => {
            return (_openBlock(), _createElementBlock("button", {
              type: "button",
              class: "color-picker",
              key: index,
              id: color,
              style: _normalizeStyle(`background-color: ${color};`),
              onClick: ($event: any) => (_ctx.selectColor(color))
            }, [
              (color == _ctx.pickedColor)
                ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                : _createCommentVNode("", true)
            ], 12, _hoisted_8))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", {
            class: _normalizeClass(`col group-icon cursor-pointer d-flex align-items-stretch ${_ctx.selectedIcon === 'Group_215.svg' ? 'icon-selected' : ''}`),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectGroupIcon($event, 'Group_215.svg')))
          }, [
            _createVNode(_component_inline_svg, { src: "/media/groups/Group_215.svg" })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`col group-icon cursor-pointer d-flex align-items-stretch mx-1 ${_ctx.selectedIcon === 'Group_216.svg' ? 'icon-selected' : ''}`),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectGroupIcon($event, 'Group_216.svg')))
          }, [
            _createVNode(_component_inline_svg, { src: "/media/groups/Group_216.svg" })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`col group-icon cursor-pointer d-flex align-items-stretch ${_ctx.selectedIcon === 'Group_217.svg' ? 'icon-selected' : ''}`),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectGroupIcon($event, 'Group_217.svg')))
          }, [
            _createVNode(_component_inline_svg, { src: "/media/groups/Group_217.svg" })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`col group-icon cursor-pointer d-flex align-items-stretch mx-1 ${_ctx.selectedIcon === 'Group_218.svg' ? 'icon-selected' : ''}`),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectGroupIcon($event, 'Group_218.svg')))
          }, [
            _createVNode(_component_inline_svg, { src: "/media/groups/Group_218.svg" })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`col group-icon cursor-pointer d-flex align-items-stretch ${_ctx.selectedIcon === 'Group_219.svg' ? 'icon-selected' : ''}`),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectGroupIcon($event, 'Group_219.svg')))
          }, [
            _createVNode(_component_inline_svg, { src: "/media/groups/Group_219.svg" })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`col group-icon cursor-pointer d-flex align-items-stretch ${_ctx.selectedIcon === 'Group_220.svg' ? 'icon-selected' : ''}`),
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectGroupIcon($event, 'Group_220.svg')))
          }, [
            _createVNode(_component_inline_svg, { src: "/media/groups/Group_220.svg" })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(`col group-icon cursor-pointer d-flex align-items-stretch ${_ctx.selectedIcon === 'Group_221.svg' ? 'icon-selected' : ''}`),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectGroupIcon($event, 'Group_221.svg')))
          }, [
            _createVNode(_component_inline_svg, { src: "/media/groups/Group_221.svg" })
          ], 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      (_ctx.v$.$error)
        ? (_openBlock(), _createElementBlock("button", _hoisted_15, " Submit "))
        : (_openBlock(), _createElementBlock("button", _hoisted_16, "Submit"))
    ])
  ], 32))
}